import { Button, Icon, Text } from '@chakra-ui/react'
import React from 'react'

import { useTabButtonStyle } from './componentStyles/TabButton.style'

type TabButtonProps = {
  isActive: boolean
  onClick: () => void
  text?: string
  leftIcon?: React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined
    }
  >
  rightIcon?: React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined
    }
  >
}
export const TabButton = ({
  isActive,
  onClick,
  text,
  leftIcon,
  rightIcon,
}: TabButtonProps) => {
  const styles = useTabButtonStyle()

  // Extract gap layout property (Chakra v3 requirement)
  const buttonLayoutProps = {
    gap: styles.button?.gap,
  }

  return (
    <Button
      flex="1"
      css={styles.button}
      {...buttonLayoutProps}
      data-active={isActive ? '' : undefined}
      aria-pressed={isActive}
      data-group
      onClick={onClick}
    >
      {leftIcon && <Icon as={leftIcon} css={styles.icon} />}
      {text && <Text css={styles.text}>{text}</Text>}
      {rightIcon && <Icon as={rightIcon} css={styles.icon} />}
    </Button>
  )
}
